// base rc-drawer 4.4.3
import Drawer from './src/DrawerWrapper';
export default Drawer;
